import { render, staticRenderFns } from "./TeacherManagement.vue?vue&type=template&id=2b50fd7d&scoped=true&"
import script from "./TeacherManagement.vue?vue&type=script&lang=js&"
export * from "./TeacherManagement.vue?vue&type=script&lang=js&"
import style0 from "./TeacherManagement.vue?vue&type=style&index=0&id=2b50fd7d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b50fd7d",
  null
  
)

export default component.exports